import React from "react";

import { Box, useTheme } from "@mui/material";

const HeaderFooterBox = ({ children }) => {
  const { palette } = useTheme();

  return (
    <Box py={1} px={6} style={{ backgroundColor: palette.backgroundGray.main }}>
      {children}
    </Box>
  );
};
export default HeaderFooterBox;
